var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33268 14.8332H15.666V8.99984H17.3327V15.6665C17.3327 16.1268 16.9596 16.4998 16.4993 16.4998H1.49935C1.03912 16.4998 0.666016 16.1268 0.666016 15.6665V8.99984H2.33268V14.8332ZM10.666 6.49984V11.4998H7.33268V6.49984H3.16602L8.99935 0.666504L14.8327 6.49984H10.666Z",
    fill: "#72777B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.c972a9443b12202554c4121b6c7fd87d.svg";
export { ForwardRef as ReactComponent };